<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Komisi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex flex-between my-3">
                  <h4 class="text-uppercase mb-0">Detail Komisi</h4>
                </div>
                <table class="responsive" v-if="komisi.length">
                  <thead>
                    <th>NO</th>
                    <th>TANGGAL</th>
                    <th>NO RAWAT</th>
                    <th>TINDAKAN/PERAWATAN</th>
                    <th>KOMISI</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in komisi" v-bind:key="item.id">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ item.formatted_tanggal }}</td>
                      <td>{{ item.no_rawat }}</td>
                      <td>{{ item.nama_komisi }}</td>
                      <td>{{ item.formatted_jumlah }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3"></td>
                      <td>
                        <h4 class="my-2">Total Komisi</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ formatted_total }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <EmptyState v-else :data="emptyObat" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import DetailTop from "@/components/DetailTop.vue";
import EmptyState from "@/components/EmptyState.vue";
// import { HTTP } from "@/config.js";
import { data } from "@/data/KomisiDetail.js";
// import {setPatientIntro,setPeriksaPetugas,setPeriksaDokter,setPeriksaOphthalmic } from "@/data/helper.js";

export default {
  name: "KomisiDetail",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    EmptyState,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      test: "hahaha",
      id_komisi: "",
      status: "",
      data: data,
      formatted_total: "Rp 0",
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottom: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-petugas/" + this.$route.params.id,
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-ophthalmic/" + this.$route.params.id,
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-dokter/" + this.$route.params.id,
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/nurse.svg",
        title: "Belum ada data tindakan",
        content: "Isi data tindakan dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/lab.svg",
        title: "Belum ada data",
        content:
          "Isi data pemeriksaan lab dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyObat: {
        img: "/img/med.svg",
        title: "Belum ada resep komisi",
        content: "Input resep komisi dengan mengeklik tombol Ubah Resep Obat",
        size: "small",
        link: "",
        label: "",
      },
      ringkasan: null,
      komisi: [],
    };
  },
  methods: {
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `komisi_ringkasan/${this.$route.params.id}`
        );

        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.ringkasan = result.data;
          let summaryArray = this.ringkasan.model_penerima.split("\\");
          let model = summaryArray[summaryArray.length - 1].toLowerCase();
          this.detailTop = {
            link: `/master/${model}/detail/${this.ringkasan.penerima.id}`,
            picture: `/img/user.jpg`,
            topSubtitle: "",
            title: this.ringkasan.penerima.formatted_nama_2,
            subtitle: this.ringkasan.penerima.kode,
            items: [],
            topRight: [
              {
                key: 1,
                columns: [
                  {
                    colnum: 12,
                    icon: "today",
                    label: "PERIODE",
                    content: this.ringkasan.periode.formatted_nama,
                  },
                ],
              },
              {
                key: 1,
                columns: [
                  {
                    colnum: 5,
                    icon: "attach_money",
                    label: "TOTAL KOMISI",
                    content: this.ringkasan.formatted_total,
                  },
                ],
              },
            ],
          };
          this.formatted_total = result.data.formatted_total;
          this.fetchList();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchList: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `komisi?id_komisi_ringkasan=${this.$route.params.id}&orderBy=asc`
        );
        let self = this;
        //console.log(result);
        if (result.status == "200") {
          self.komisi = result.data.data.map((item) => {
            //console.log(item);
            item.key = item.id;
            return item;
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.data.actionBtn[0].link =
      this.data.actionBtn[0].link + this.$route.params.id;
    this.displayData();
  },
};
</script>
